import { IResultAndError } from '../ChoiceApi';
import { popAlert } from '../Notification';
// Generic result response
export interface IResult 
{ 
    successful: boolean, 
    statusDescription?: string 
};

// If there is an unsuccessful report, show an error message & return true
export async function showResultError(result: IResult|undefined, context: string): Promise<boolean>
{
    if (!result)
    {
        await popAlert("Error trying to call CMM");
        return true;
    }

    if (!result.successful)
    {
        await popAlert(`${context}: ${result.statusDescription ?? "unknown issue"}`);
        return true;
    }
    return false;
}